import { render, staticRenderFns } from "./annualChannel.vue?vue&type=template&id=17a43c49&scoped=true&"
import script from "./annualChannel.vue?vue&type=script&lang=js&"
export * from "./annualChannel.vue?vue&type=script&lang=js&"
import style1 from "./annualChannel.vue?vue&type=style&index=1&id=17a43c49&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a43c49",
  null
  
)

export default component.exports